
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSearchlight as ObiLightSearchlightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-searchlight.js';
 
 
 

 
 export const ObiLightSearchlight = createComponent({
   react: React,
   tagName: 'obi-light-searchlight',
   elementClass: ObiLightSearchlightElement,
   events: {
     
   }
  });
 
 